import { render, staticRenderFns } from "./UserAccessControlList.vue?vue&type=template&id=87eeea9c"
import script from "./UserAccessControlList.vue?vue&type=script&lang=js"
export * from "./UserAccessControlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports